module.exports = __webpack_public_path__ + "media/country_flags/sa-b8f0311f.png";